import { createContext, useContext, useEffect, useState } from 'react';

const TextsContext = createContext({ texts: {}, ready: false, canEdit: false });

export const useTexts = () => useContext(TextsContext);

export function TextsProvider({ children }) {
  const [texts, setTexts] = useState({});
  const [ready, setReady] = useState(false);
  const canEdit = new URLSearchParams(window.location.search).has('edit');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/texts`)
      .then((r) => r.json())
      .then((data) => setTexts(data || {}))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  return (
    <TextsContext.Provider value={{ texts, ready, canEdit }}>
      {children}
    </TextsContext.Provider>
  );
}
